import request from "@/components/common/utils/request.js"

export function api_sourcesList_traffic(obj) {
	return request({
		url: '/api/traffic/sources/list',
		method: 'get',
		params : obj
	})
}

export function api_sourcesListV1_traffic(obj) {
	return request({
		url: '/api/traffic/sources/list/v1',
		method: 'get',
		params : obj
	})
}

export function api_wordList_traffic(obj) {
	return request({
		url: '/api/traffic/word/list',
		method: 'get',
		params : obj
	})
}

export function api_wordCounts_traffic(obj) {
	return request({
		url: '/api/traffic/public/word/counts',
		method: 'get',
		params : obj
	})
}

export function api_asinKeywordList_traffic(obj) {
	return request({
		url: '/api/traffic/keywordTrends',
		method: 'get',
		params : obj
	})
}

export function api_searchAsinListByKeywords_traffic(obj) {
	return request({
		url: '/api/traffic/public/searchAsinListByKeywords',
		method: 'get',
		params : obj
	})
}

export function api_searchAsinHistoryByKeywords_traffic(obj) {
	return request({
		url: '/api/traffic/public/searchAsinHistoryByKeywords',
		method: 'get',
		params : obj
	})
}